import React, { useEffect, useState } from "react";
import { db } from "../FirebaseConfig";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, deleteDoc, doc, query, where } from "firebase/firestore";

const AdminDashboard = ({ isSigned, CampusEmails, userEmail }) => {
   const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [propertyCount, setPropertyCount] = useState(0);
  const [landlordCount, setLandlordCount] = useState(0);
  const [caretakerCount, setCaretakerCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [agentCount, setAgentCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!CampusEmails?.includes(userEmail)) { 
      navigate('/');
    }
  }, [CampusEmails, userEmail, navigate]);
        
        
    useEffect(() => {
      if (!isSigned) {
        setTimeout(() => navigate('/login'), 3000);
      }
    }, [isSigned, navigate]);

  const fetchStats = async () => {
    setLoading(true);

    // Get properties
    const propertySnap = await getDocs(collection(db, "listings"));
    const propertyData = propertySnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setProperties(propertyData);
    setPropertyCount(propertyData.length);

    // Get landlords
    const getCountByRole = async (role) => {
        const snap = await getDocs(query(collection(db, "users"), where("role", "==", role)));
        return snap.size;
      };
    
      const landlordCount = await getCountByRole("LandLord");
      const caretakerCount = await getCountByRole("care taker");
      const studentCount = await getCountByRole("Student");
      const agentCount = await getCountByRole("Agent");
    
      // Set counts
      setLandlordCount(landlordCount);
      setCaretakerCount(caretakerCount);
      setStudentCount(studentCount);
      setAgentCount(agentCount);

    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this property?")) {
      await deleteDoc(doc(db, "listings", id));
      setProperties(properties.filter((item) => item.id !== id));
      setPropertyCount(prev => prev - 1);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <div className="min-h-screen p-6 bg-transparent text-gold">
      <h1 className=" text-2xl lg:text-5xl font-semibold mb-4 animate-bounce">Welcome Dogus</h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {/* Summary Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mb-6">
            <div className="bg-white/10 shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold">Total Properties</h2>
              <p className="text-3xl font-bold">{propertyCount}</p>
            </div>
            <div className="bg-white/10 shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold">Total Landlords</h2>
              <p className="text-3xl font-bold">{landlordCount}</p>
            </div>
            <div className="bg-white/10 shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold">Total Student</h2>
              <p className="text-3xl font-bold">{studentCount}</p>
            </div>
            <div className="bg-white/10 shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold">Total Agent</h2>
              <p className="text-3xl font-bold">{agentCount}</p>
            </div>
            <div className="bg-white/10 shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold">Total Care taker</h2>
              <p className="text-3xl font-bold">{caretakerCount}</p>
            </div>
          </div>

          {/* Property List */}
          <h2 className="text-xl font-semibold mb-4">Recent Properties</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white/10 rounded shadow">
              <thead>
                <tr className="bg-white/10">
                  <th className="text-left px-4 py-2">Title</th>
                  <th className="text-left px-4 py-2">Price</th>
                  <th className="text-left px-4 py-2">Location</th>
                  <th className="text-left px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {properties.map((prop) => (
                  <tr key={prop.id} className="border-t">
                    <td className="px-4 py-2">{prop.title || "N/A"}</td>
                    <td className="px-4 py-2">₦{prop.price || "N/A"}</td>
                    <td className="px-4 py-2">{prop.location || "N/A"}</td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => handleDelete(prop.id)}
                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {properties.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center py-4 text-gray-500">
                      No properties available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDashboard;
